import {
  AudienceType,
  AudienceTypeNoAB,
  CommunicationAudienceType,
  SelectedStartType,
  TargetedAtType,
} from "../../config/enums";
import { enumToOptions } from "../../blocks/fields/enumToOptions";
import { RadioFieldOption } from "../../blocks/fields/RadioField.types";

export const communicationEntityName = "g4c_communication";

export const communicationTypeOptions = enumToOptions(CommunicationAudienceType);
export const communicationTargetedAtOptions = enumToOptions(TargetedAtType);

export const communicationTargetedAtRadioOptions: RadioFieldOption[] = [
  { label: "Account", value: TargetedAtType.Account, description: "Sent to the accounts in the audience." },
  { label: "Contact", value: TargetedAtType.Contact, description: "Sent to the contacts in the audience." },
];
export const communicationStartTypeOptions = enumToOptions(SelectedStartType);
export const communicationAudienceTypeOptions = enumToOptions(AudienceTypeNoAB);
export const communicationAudienceTypeABOptions = enumToOptions(AudienceType);
